// extracted by mini-css-extract-plugin
export default {"Box":"potentially-dirty-module__Box__pON1J2U","PotentiallyDirty":"potentially-dirty-module__PotentiallyDirty__ueMTVIJ","hasChildren":"potentially-dirty-module__hasChildren__INfKM22"};